import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { useLocation } from '../../helpers/useRouter';
import FeatureFlag from '../general/FeatureFlag';
import Icon from '../general/Icon';
import config from '../../config';
import DimensionsStore from '../../stores/DimensionsStore';
import connectToStores from '../../helpers/connectToStores';
import { translate as t } from '../../lib/I18n';
import TrackingActions from '../../actions/TrackingActions';

const Webchat = ({ isMobile }) => {
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);
    const [isAllowed, setIsAllowed] = useState(false);

    const [iframeSrc, prohibitedPaths] = useMemo(
        () => [config.get('webchatIframeSrc') || '', config.get('webchatProhibitedPaths')],
        [],
    );

    useEffect(() => {
        const isProhibited =
            Array.isArray(prohibitedPaths) &&
            prohibitedPaths.some(pathSubstring => location.pathname.includes(pathSubstring));

        setIsAllowed(!isProhibited);
    }, [location, prohibitedPaths]);

    const handleClick = () => {
        setIsOpen(!isOpen);

        if (!isOpen) {
            TrackingActions.webchatOpened();
        }
    };

    return (
        <FeatureFlag name="enableWebchat">
            <div className="webchat__container hidden-print ">
                {isOpen && isAllowed && !isMobile && (
                    <iframe
                        id="webchat"
                        title={t('ariaLabel.iframe.webchat')}
                        className="webchat__iframe"
                        src={iframeSrc}
                        width="375"
                        height="600"
                    />
                )}
                {isAllowed && !isMobile && (
                    <button
                        className="webchat__toggle"
                        onClick={handleClick}
                        tabIndex="0"
                        aria-label={t('ariaLabel.webchatButton')}
                    >
                        <Icon icon={isOpen ? 'close' : 'chat'} />
                    </button>
                )}
            </div>
        </FeatureFlag>
    );
};

Webchat.propTypes = {
    isMobile: PropTypes.bool,
};

export default connectToStores([DimensionsStore], () => {
    return {
        isMobile: DimensionsStore.isMobileWidth(),
    };
})(Webchat);
